<template>
    <div class="p-3">
        <el-card :header="product.name">
            <el-skeleton :loading="loading" animated :rows="12">
                <template #default>
                    <el-row v-if="!product.id" justify="center" align="middle">
                        <el-col :sm="12" :lg="7">
                            <el-result
                                icon="error"
                                title="Produto não encontrado"
                                sub-title="O produto que procura não foi encontrado, por favor verifique se consta da lista"
                            >
                                <template #extra>
                                    <el-button type="primary" icon="View">Produtos</el-button>
                                </template>
                            </el-result>
                        </el-col>
                    </el-row>
                    <template v-else>
                        <el-row :gutter="20">
                            <el-col :md="16" :lg="14">
                                <el-form :rules="rules" ref="formRef" :model="product" :disabled="updating" label-position="top">
                                    <el-row :gutter="20" justify="center">
                                        <el-col :sm="24" :md="10">
                                            <el-form-item label="Nome do produto" prop="name">
                                                <el-input v-model="product.name" name="name" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :sm="24" :md="7">
                                            <el-form-item label="Produto activo" prop="active">
                                                <el-switch style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949" active-text="Activo" inactive-text="Inativo" v-model="product.active" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :sm="24" :md="7">
                                            <el-form-item label="Quantidade em estoque" prop="quantity">
                                                <el-input-number name="quantity" :step="1" v-model="product.quantity" :min="0" class="col-12" />
                                            </el-form-item>
                                        </el-col>
        
                                        <el-col :sm="24">
                                            <el-row :gutter="20">
                                                <el-col :sm="24" :md="7">
                                                    <el-form-item label="preço de promoção" prop="promoction">
                                                        <el-input-number name="promoction" v-model="product.promoction" :min="0" class="col-12" />
                                                    </el-form-item>
                                                </el-col>
                                                
                                                <el-col :sm="24" :md="7">
                                                    <el-row :gutter="20">
                                                        <el-col>
                                                            <el-form-item label="preço normal" prop="price">
                                                                <el-input-number name="price" v-model="product.price" :min="0.001" class="col-12" />
                                                            </el-form-item>
                                                        </el-col>
                                                    </el-row>
                                                </el-col>
                                                <el-col :sm="24" :md="10">
                                                    <el-form-item label="Categorias" prop="categories">
                                                        <el-select v-model="product.categories" name="categories" multiple :filterable="true">
                                                            <el-option v-for="c in categories" :value="c.id" :label="c.name" :key="c.id">{{ c.name }}</el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                        </el-col>
    
                                        <el-col>
                                            <el-form-item label="Descricao" prop="description">
                                                <el-input type="textarea" clearable name="descricao" v-model="product.description" />
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
        
                                    <el-row :gutter="25">
                                        <el-col class="col-auto">
                                            <el-button plain type="primary" size="large" :loading="updating" @click.prevent="update(formRef)">
                                                Salvar alterações
                                            </el-button>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </el-col>
                            <el-col :md="8" :lg="10" style="height: 100%" class="overflow-y-scroll">
                                <el-col>
                                    <h6>Galeria</h6>
                                    <el-button v-if="checks.length > 0" plain type="danger" @click="deleteChecks">Eliminar seleciondas</el-button>
                                    <el-divider />
                                </el-col>
                                <el-row :gutter="20">
                                    <el-col :sm="12" :md="8" v-for="img in product.images" :key="(img as Image).id">
                                        <input type="checkbox" class="delete-check" name="checks[]" v-model="checks" :value="(img as Image).id">
                                        <video v-if="isVideoFile((img as Image).url ?? '')" controls class="col-12">
                                            <source :src="`${Api.publicUrl}images/products/${(img as Image).url}`" />
                                        </video>
                                        <el-image v-else alt="" :src="`${Api.publicUrl}images/products/${(img as Image).url}`" class="col-12" />
                                    </el-col>
                                </el-row>
                                <h6>Adicionar imagens</h6>
                                <input type="file" multiple name="files" @change="handleFiles" />
                                <el-button plain type="primary" class="my-3" @click="sendImages">Adicionar imagens</el-button> 
                            </el-col>

                            <el-col :md="24">
                                <el-divider />
                                <h6>Propriedades</h6>

                                <el-row :gutter="10" class="py-4 px-2">
                                    <span class="col-12 py-1">Adicionar propriedade</span>
                                    <el-input v-model="newProp.property" placeholder="Inserir Propriedade" class="col-4 mx-2" />
                                    <el-input v-model="newProp.value" placeholder="Inserir valor" class="col-4 mx-2"  />
                                    <el-button :loading="newProp.loading" @click="() => sendProp(newProp)">
                                        <el-icon><Plus /></el-icon>
                                    </el-button>
                                </el-row>
                                <div v-if="product.properties?.length == 0" class="text-grey mb-4">
                                    Nenhuma propriedade adicionada
                                </div>
                                <template v-else-if="product.properties">
                                    <personal-table :rows="10" :loading="false" :data="product.properties" :cols="[
                                        {prop: 'id', label: '#', sortable: true}
                                    ]">
                                        <el-table-column label="Propriedade" class-name="auto" :min-width="150">
                                            <template #default="data">
                                                <el-input v-model="data.row.property" placeholder="Inserir Propriedade" v-if="editProp == data.row.id" />
                                                <span v-else>
                                                    {{ data.row.property }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Valor" class-name="auto" :min-width="150">
                                            <template #default="data">
                                                <el-input v-model="data.row.value" placeholder="Inserir valor da propriedade" v-if="editProp == data.row.id" />
                                                <span v-else>
                                                    {{ data.row.value }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Acções" class-name="auto" :min-width="150">
                                            <template #default="data">
                                                <el-row>
                                                    <span class="p-2" v-if="editProp == data.row.id">
                                                        <el-button :loading="data.row.loading" type="success" icon="Finished" title="Editar" @click="() => sendProp(data.row)"></el-button>
                                                    </span>
                                                    <span class="p-2" v-else>
                                                        <el-button :loading="data.row.loading" type="warning" icon="EditPen" title="Editar" @click="() => editProp = data.row.id"></el-button>
                                                    </span>
                                                    <span class="p-2">
                                                        <el-button :loading="data.row.loading" type="danger" icon="Delete" title="Eliminar" @click="() => removeProp(data.row)"></el-button>
                                                    </span>
                                                </el-row>
                                            </template>
                                        </el-table-column>
                                    </personal-table>
                                </template>
                            </el-col>
                        </el-row>

                    </template>
                </template>
            </el-skeleton>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import PersonalTable from "@/components/PersonalTable.vue";
    import Api from "@/services/api";
    import { Category, Product, Property } from "@/services/types";
    import { ElButton, ElIcon, ElInput, ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus";
    import { onBeforeMount, reactive, ref, watchEffect } from "vue";
    import { useRoute, useRouter } from "vue-router";
    import { useStore } from "vuex";
    type Image = {
        id?: number
        url?: string
    }
    const route = useRoute()
    const router = useRouter()
    const {id} = route.params
    const loading = ref<boolean>(true)
    const editProp = ref<number>(-1)
    const newProp = reactive<Property>({
        property: '',
        value: '',
        id: -5,
        loading: false
    })
    const updating = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const checks = ref<number[]>([])
    const store = useStore()

    const selectedFiles = ref<FileList | null>(null)

    const handleFiles = (event: Event) => {
        const target = event.target as HTMLInputElement
        selectedFiles.value = target.files
        console.log(selectedFiles.value)
    }

    const deleteChecks = async () => {
        if (checks.value.length < 1) {
            return
        }

        loading.value = true
        const params = new URLSearchParams();

        checks.value.forEach((value: number)  => {
            params.append('images[]', value.toString());
        });
        try {
            const res = await Api.delete(`admin/products/images/${id}?${params.toString()}`)
            console.log(res)
            product.images = res.data.product.images
            checks.value = []
        } catch(e) {
            ElMessage.error("Ocorreu um erro" + e)
            console.log(e)
        } finally {
            loading.value = false
        }
    }

    const sendImages = async () => {
        if (!selectedFiles.value || selectedFiles.value.length === 0) {
            console.warn("Nenhum arquivo selecionado")
            return
        }

        console.log(90)

        loading.value = true
        const formData = new FormData()
        for (let i = 0; i < selectedFiles.value.length; i++) {
            formData.append('images[]', selectedFiles.value[i])
        }
        try {
            const res = await Api.post("admin/products/images/" + id, formData, formData)
            product.images = res.data.product.images
            console.log(res)
            selectedFiles.value = []
        } catch(e) {
            console.log(e)
            ElMessage.error("Ocorreu um erro " + e)
        } finally {
            loading.value = false
        }
    }

    const product = reactive<Product>({
        description: '',
        name: '',
        price: 0,
        properties: [],
        images: [],
        categories: [],
    })

    const rules = reactive<FormRules<Product>>({
        name: [{required: true, message: 'Insira o nome do produto'}],
        price: [{required: true, message: 'Informe o preco'}],
        quantity: [{required: true, message: 'Informe a quantidade'}],
        categories: [{required: true, message: 'Escolha pelo menos uma categoria'}],
        description: [{required: true, message: 'Descreva este produto'}],
    })

    const categories = reactive<Array<Category>>([])
    const isVideoFile = (filename: string): boolean => {
        const videoExtensions = [".mp4", ".avi", ".mpeg", ".quicktime", ".webm"];
        return videoExtensions.some(ext => filename.endsWith(ext));
    }

    const getProduct = async () => {
        console.log(90000)
        loading.value = true
        const res = await Api.get('admin/products/' + id)
        if (res.status == 200) {
            const p = res.data.product   
            product.name = p.name
            product.description = p.description
            product.price = p.price
            product.quantity = p.quantity
            product.promoction = p.promoction
            product.images = p.images
            product.id = p.id
            product.active = p.active
            product.categories = p.categories.map((c: Category) => c.id)
            product.created_at = p.created_at
            product.properties = p.properties.filter((prop: Property) => prop.value != null)                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
        } else if (res.status != 404) {
            ElMessageBox.alert('Ocorreu um erro ' + res.data.message, {type: "error"}).then(() => router.push('/products')).catch(() => router.push('/products'))
        }
        loading.value = false
    }

    onBeforeMount(async () => {
        loading.value = true
        console.log(80000)
        const res1 = await Api.get('admin/categories')
        console.log(80000)
        if (res1.status != 200) {
           ElMessageBox.alert('Ocorreu um erro ' + res1.data.message)
        } else {
            const data = res1.data.categories
            categories.splice(0)
            data.forEach((element: Category) => {
                categories.push(element)
            });
        }

        await getProduct()

        loading.value = false
    })

    const update = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                loading.value = true
                const data = new FormData()
                data.append('name', product.name)
                data.append('price', product.price.toString())
                data.append('quantity', (product.quantity ?? 0).toString())
                if (product.active) { data.append('active', '1') } else { data.append('active', '0') }
                data.append('description', product.description);
                product.promoction && data.append('promoction', product.promoction?.toString());
                
                // categorias
                product.categories?.forEach((c, i) => {
                    data.append(`categories[${i}]`, c.toString())
                })

                const res = await Api.put('admin/products/' + id, product, data)
                console.log(res.data)

                if (res.status == 200) {
                    ElMessage.success({message: 'Actualizado com sucesso'})
                    // location.reload()
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                loading.value = false
            }
        })
    }

    const removeProp = async (prop: Property) => {
        prop.loading = true
        await sendProp(Object.assign({}, prop, {value: ''}))
        prop.loading = false
    }

    const sendProp = async (prop: Property) => {
        prop.loading = true
        const form = new FormData()
        form.append(`properties[${prop.property}]`, prop.value)
        const res = await Api.post(`admin/products/${product.id}`, {}, form)
        console.log(res.data)
        if (res.status == 200) {
            product.properties = res.data.product.properties
        } else {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
        }

        editProp.value = -1
        prop.loading = false
    }

    const openModal = () => {
        store.commit('setOpenModal', 4)
    }

    // atualizar props depois de adicionar
    store.watch((state, getter) => getter.openModal, async (n, o) => {
        o == 4 && await getProduct()
    })

    watchEffect(() => {
        console.log(checks.value)
    })
</script>
<style lang="scss" scoped>
    .delete-check {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 4;
    }
    *:has(>.delete-check) {
        position: relative;
    }
</style>